import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { retry, catchError, tap } from 'rxjs/operators';
import { SharedService } from '../services/shared.service';
import { IPaymentResponse } from '../interfaces/payment-response';

@Injectable({
  providedIn: 'root'
})
export class PaymentsService {

  private disburseFundsUrl = '/client/payments/{billerId}';

  constructor(
    private http: HttpClient,
    private sharedService: SharedService
  ) { }

  public disburseFunds(fundingAccountToken: string, disbursementOccurrenceUuid: string): Observable<IPaymentResponse> {
    // console.log('disburseFunds: fundingAccountToken ', fundingAccountToken);
    let envRegion: string = this.sharedService.getEnvRegion();
    let sessionId: string = this.sharedService.getDisbursementSession().sessionId;
    let billerId: string = this.sharedService.getDisbursementSession().billerId;
    let headers = new HttpHeaders()
      .set('session-id', sessionId);
    let url = this.sharedService.getDisbursementsBaseUrl(envRegion) + this.disburseFundsUrl;
    url = url.replace("{billerId}", billerId);
    let request = {
      "fundingAccountToken": fundingAccountToken,
      "disbursementOccurrenceUuid": disbursementOccurrenceUuid
    };
    // console.log('disburseFunds: request ', request);
    // console.log('disburseFunds: this.http ', this.http);
    return this.http.post<IPaymentResponse>(url, request, {headers: headers, responseType: 'json'})
    .pipe(
      catchError(this.sharedService.handleError)
    )
  }  

}
